import { useEffect, useState } from "react";
import {
  getProductsFromCachedBasketCookie,
  ProductsInBasket,
} from "@~/utils/product.ts";
import { EVENTS } from "@~/product-card-components/__shared__/AddToBasketUtils/basketEvents.ts";

const BASKET_QTY_UPDATED_EVENT = "jl-events.browser.basketQuantityUpdated";

export function useCachedBasketData(): ProductsInBasket {
  const [cachedBasketData, setCachedBasketData] = useState<ProductsInBasket>(
    [],
  );

  const updateCachedBasketData = () => {
    setCachedBasketData(getProductsFromCachedBasketCookie());
  };

  useEffect(function subscribeToBasketQuantityUpdates() {
    updateCachedBasketData();
    window.addEventListener(BASKET_QTY_UPDATED_EVENT, updateCachedBasketData);
    window.addEventListener(
      EVENTS.JL_EVENTS_ADD_TO_BASKET_SUCCESS,
      updateCachedBasketData,
    );

    return function unsubscribeFromBasketQuantityUpdates() {
      window.removeEventListener(
        BASKET_QTY_UPDATED_EVENT,
        updateCachedBasketData,
      );
      window.removeEventListener(
        EVENTS.JL_EVENTS_ADD_TO_BASKET_SUCCESS,
        updateCachedBasketData,
      );
    };
  }, []);

  return cachedBasketData;
}
